import React from 'react';

const Focus = () => {
  return (
    // <div className="section">
    <div className="section" id="journey">
      <div className="header">
      <h1>Rhodium Root Journey</h1>
      <h2>Tracking health, learning in public, building tools</h2>
      <hr className="custom-line" />
    </div>
    <h2>The Journey</h2>
      <div className="text-image-wrapper">
        <img 
          src="/images/RhodiumRMain.png" 
          alt="Health optimization journey image" 
          className="journey-image" 
        />
        <p>
          Welcome to my journey in health optimization, longevity, and practical biohacking.
          <br />
          <br />
          Everything here is tracked, tested, and shared without outside sponsorships or incentives.
          <br />
          <br />
          I started later in life, so the focus is real-world progress rather than perfection. The work centers on six pillars: Research, Exercise, Nutrition, Testing, Recovery, and Discipline.
          <br />
          <br />
          I document the experiments, results, and practical lessons as I learn what actually moves healthspan.
          Rhodium Life is the companion app I built to log the data behind those decisions.
          <br />
          <br />
          <a
            href="https://apps.apple.com/app/id6756220909"
            target="_blank"
            rel="noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
          >
            <img
              src="/images/RhodiumLifeIcon.png"
              alt="Rhodium Life app icon"
              style={{ width: '44px', height: '44px', borderRadius: '10px' }}
            />
            <span className="card-container-button" style={{ display: 'inline-block', width: 'auto', margin: 0 }}>
              Get the Rhodium Life App
            </span>
          </a>
        </p>
      </div>
      <div className="card-container">
        <div className="card">
          <h3>Research</h3>
          <i>Building a Foundation</i>
          <p>
            Research is important. Every decision is informed by literature from PHDs or top biohacking individuals and Artificial Intelligence insights. By tracking metrics over time, I gather real, actionable data to refine and evolve the approach continuously.
          </p>
        </div>

        <div className="card">
          <h3>Exercise</h3>
          <i>Training for Peak Performance</i>
          <p>
            Exercise focusing on protocols that can be incorporated daily for the normal working individual and help to focus on longevity and overtime efficiency. Techniques range from cardiovascular conditioning and endurance-focused training to mobility, resilience, and stability work. Each is selected for its benefits in promoting heart health and longevity.
          </p>
        </div>

        <div className="card">
          <h3>Nutrition</h3>
          <i>Fueling Longevity at a Cellular Level</i>
          <p>
            Nutrition is tailored to support energy, cognition, and longevity. This involves tracking macronutrient and micronutrient intake, adapting meal plans, and using fasting strategies based on longevity research. Nutritional adjustments are data-driven, ensuring that every meal supports metabolic health and vitality.
          </p>
        </div>

        <div className="card">
          <h3>Testing</h3>
          <i>Uncovering the Individual Body</i>
          <p>
            Testing provides an internal snapshot of health, from nutrient levels to metabolic efficiency. Regular testing ensures that I’m not just guessing but targeting specific areas that need support. Each test builds a clearer roadmap to optimize my foundation.
          </p>
        </div>

        <div className="card">
          <h3>Recovery</h3>
          <i>The Essential Role of Rest</i>
          <p>
            Recovery is just as important as effort. It allows the body to repair and adapt to the stressors imposed by exercise and daily activity. Prioritizing sleep, nutrition, and stress management leads to better results and supports long-term health.
          </p>
        </div>

        <div className="card">
          <h3>Discipline</h3>
          <i>Cultivating a Mental Edge for Longevity</i>
          <p>
            Mental discipline is essential to navigating this journey. Emphasizing mindfulness to build a mindset that fosters discipline, motivation, and adaptability—key components for sustained health optimization.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Focus;
